import { useAsyncFn } from 'react-use'
import { useCurrentOrg } from 'auth/hooks'
import { editQuestionSet } from 'surveys/api'
import { useCreateSurveyVersion, useCreateSurvey } from 'surveys/hooks'

export interface SaveSurveyPayload {
  name: string
  questions: unknown[]
  questionsEdited?: boolean
  updateMinimumRequiredVersion?: boolean
}

// TODO trying out a thinner call w/ a generic async wrapper
export const useSaveSurvey = () => {
  const currentOrg = useCurrentOrg()
  const [createSurveyVersion] = useCreateSurveyVersion()
  const [createSurvey] = useCreateSurvey()
  return useAsyncFn(
    async (payload: SaveSurveyPayload, surveyId?: number) => {
      const questionSet = await editQuestionSet(currentOrg.id, payload)

      const { questionSetId } = questionSet
      if (surveyId) {
        const { updateMinimumRequiredVersion = true } = payload
        return createSurveyVersion(surveyId, { questionSetId, updateMinimumRequiredVersion })
      }
      return createSurvey({ questionSetId })
    },
    [currentOrg.id],
  )
}

export default useSaveSurvey
